<template>
	<v-container fluid class="px-0" id="listado-consultas">
		<!-- Sentinel: 1px invisible antes del card, para que IntersectionObserver detecte cuando el card se vuelve sticky sin feedback loop -->
		<!-- <div ref="stickySentinel" class="sticky-sentinel"></div> -->
		<v-card class="mb-2 py-1 listing-header-card">
			<v-card-text class="header-table-card py-2">
				<!-- DESKTOP VERSION: todas las columnas -->
				<v-row v-if="!isMobile">
					<v-col cols="1" class="pb-1">
						<v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;" @click="toggleOrder">
							<v-icon color="#5e85ef" small class="mr-1">{{getIconOrder()}}</v-icon>
							<p class="mb-0 font-weight-bold body-2 text-capitalize">Número</p>
						</v-btn>
					</v-col>
					<v-col cols="2" class="pb-1">
						<v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;" @click="toggleOrder">
							<p class="mb-0 font-weight-bold body-2 text-capitalize">Detalle / Estado</p>
						</v-btn>
					</v-col>
					<v-col cols="2" class="pb-1">
						<v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;">
							<p class="mb-0 font-weight-bold body-2 text-capitalize">Avance</p>
						</v-btn>
					</v-col>
					<v-col cols="7" class="pb-1">
						<div class="d-flex align-center mb-2">
							<div class="d-flex align-center w-100" style="z-index: 2;">
								<p class="mb-0 font-weight-bold body-2 text-capitalize">Estados de Pago</p>
								<v-tooltip bottom v-if="canCreateNewPaymentStatus">
									<template v-slot:activator="{ on, attrs }">
										<v-btn text icon style="height: auto;"
											v-bind="attrs"
											v-on="on"
											@click="addPaymentStatus">
											<v-icon color="#5e85ef" small>mdi-plus-circle</v-icon>
										</v-btn>
									</template>
									<span>Crear Nuevo Estado de Pago</span>
								</v-tooltip>
							</div>
							<div class="d-flex align-center" style="gap: 5px;">
								<div style="align-self: center;width: 180px;">
									<v-select
										v-model="selectedCurrency"
										:items="currencyOptions"
										item-text="label"
										item-value="id"
										outlined
										dense
										height="28"
										@change="onCurrencyChange"
										class="currency-selector ma-0"
										style="max-width: 250px; font-size: 0.75rem;"
										hide-details
									>
										<template v-slot:prepend-inner>
											<v-icon size="14" color="#2D4B95">mdi-currency-usd</v-icon>
										</template>
									</v-select>
								</div>
								<v-btn
									outlined
									x-small
									color="#2D4B95"
									@click="debouncedGetAdditionalInformativeTable()"
									:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99"
								>
									<v-icon small>mdi-refresh</v-icon>
									<p class="mb-0 ml-1">Recargar</p>
								</v-btn>
								<v-menu offset-y class="custom-speed-dial-export">
									<template v-slot:activator="{ on, attrs }">
										<v-btn dark x-small color="#2D4B95" v-bind="attrs" v-on="on">
											<div class="d-flex align-center">
												<v-icon small>mdi-microsoft-excel</v-icon>
												<p class="mb-0 ml-1">Exportar</p>
											</div>
										</v-btn>
									</template>
									<div class="white pa-2 d-flex flex-column" style="gap: 5px;border: 1px solid #2D4B95!important;border-radius: 4px;">
										<v-btn dark x-small block color="#2D4B95" @click="combinedExportExcel(2)">
											<p class="mb-0 ml-1">Exportar En Pesos (CLP)</p>
										</v-btn>
										<v-btn dark x-small block color="#2D4B95" @click="combinedExportExcel(3)">
											<p class="mb-0 ml-1">Exportar En UF</p>
										</v-btn>
										<v-btn dark x-small block color="#2D4B95" @click="combinedExportExcel(1)">
											<p class="mb-0 ml-1">Exportar En USD</p>
										</v-btn>
									</div>
								</v-menu>
							</div>
						</div>
					</v-col>
				</v-row>

				<!-- MOBILE VERSION: solo Número, crear EP, recargar y exportar -->
				<v-row v-else>
					<v-col cols="2" class="pb-1">
						<v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;" @click="toggleOrder">
							<v-icon color="#5e85ef" small class="mr-1">{{getIconOrder()}}</v-icon>
							<p class="mb-0 font-weight-bold body-2 text-capitalize">Número</p>
						</v-btn>
					</v-col>
					<v-col cols="10" class="pb-1">
						<div class="d-flex align-center justify-end" style="gap: 5px;">
							<v-tooltip bottom v-if="canCreateNewPaymentStatus">
								<template v-slot:activator="{ on, attrs }">
									<v-btn text x-small style="height: auto;"
										v-bind="attrs"
										v-on="on"
										@click="addPaymentStatus">
										<v-icon color="#5e85ef" small class="mr-1">mdi-plus-circle</v-icon>
										<p class="mb-0">Nuevo EP</p>
									</v-btn>
								</template>
								<span>Crear Nuevo Estado de Pago</span>
							</v-tooltip>
							<v-menu offset-y>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										outlined
										x-small
										color="#2D4B95"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small>mdi-currency-usd</v-icon>
									</v-btn>
								</template>
								<v-list dense class="mobile-ep-selector">
									<v-list-item
										v-for="currency in currencyOptions"
										:key="currency.id"
										@click="selectedCurrency = currency.id; onCurrencyChange()"
										:class="selectedCurrency === currency.id ? 'v-list-item--active primary--text' : ''"
									>
										<v-list-item-content>
											<v-list-item-title>{{ currency.label }}</v-list-item-title>
										</v-list-item-content>
										<v-list-item-icon v-if="selectedCurrency === currency.id">
											<v-icon color="primary" small>mdi-check</v-icon>
										</v-list-item-icon>
									</v-list-item>
								</v-list>
							</v-menu>
							<v-btn
								outlined
								x-small
								color="#2D4B95"
								@click="debouncedGetAdditionalInformativeTable()"
								:loading="$store.adicionalesStore.state.listado.status === 99"
							>
								<v-icon small>mdi-refresh</v-icon>
							</v-btn>
							<v-menu offset-y class="custom-speed-dial-export">
								<template v-slot:activator="{ on, attrs }">
									<v-btn dark x-small color="#2D4B95" v-bind="attrs" v-on="on">
										<v-icon small>mdi-microsoft-excel</v-icon>
									</v-btn>
								</template>
								<div class="white pa-2 d-flex flex-column" style="gap: 5px;border: 1px solid #2D4B95!important;border-radius: 4px;">
									<v-btn dark x-small block color="#2D4B95" @click="combinedExportExcel(2)">
										<p class="mb-0 ml-1">Exportar En Pesos (CLP)</p>
									</v-btn>
									<v-btn dark x-small block color="#2D4B95" @click="combinedExportExcel(3)">
										<p class="mb-0 ml-1">Exportar En UF</p>
									</v-btn>
									<v-btn dark x-small block color="#2D4B95" @click="combinedExportExcel(1)">
										<p class="mb-0 ml-1">Exportar En USD</p>
									</v-btn>
								</div>
							</v-menu>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col :cols="isMobile ? 12 : 5" class="pt-1">
						<!-- Componentes gráficos: ocultar cuando sticky en desktop -->
						<div class="sticky-collapsible" :class="{ 'is-hidden': isHeaderSticky && !isMobile }">
							<ProjectDetailCard
								v-if="graphInfo && summaryInfoType == 1"
								type="additional" 
								:data="graphInfo ? graphInfo.additional : null"
							/>
							<AdditionalsSimpleSummary v-show="summaryInfoType == 2" />
						</div>
					</v-col>
					<v-col :cols="isMobile ? 12 : 7" class="pt-1">
						<div class="d-flex align-center flex-column">
							<div class="w-100">

								<!-- ===== DESKTOP: scroll horizontal (sin cambios) ===== -->
								<v-row align="center" class="flex-nowrap overflow-auto"
									ref="scrollHeaderContainer"
									style="overflow-x: auto; white-space: nowrap;"
									v-if="!isMobile && (newPaymentStatus || ($store.adicionalesStore.state.listadoInformativeTable.payment_statuses && $store.adicionalesStore.state.listadoInformativeTable.payment_statuses.length > 0))">
									<v-col cols="3"
										:class="{ 'custom-first-row-payment-status-header': index === 0 }"
										:align-self="index === 0 ? 'stretch' : 'start'"
										style="min-width: 250px;"
										v-for="(ps, index) in reorderedPaymentStatuses" :key="ps.id">
										<div v-if="ps.newPaymentStatus" class="new-payment-status-container mt-1">
											<div class="d-flex align-center justify-center" style="gap: 8px; margin-bottom: 8px;">
												<v-icon color="#2D4B95" small>mdi-plus-circle</v-icon>
												<p class="caption font-weight-bold mb-0">Nuevo Estado de Pago</p>
											</div>
											<p class="caption text--secondary mb-2" style="text-align: center; line-height: 1.3;">
												<small>Ingresa el avance en los adicionales que deseas incluir en este estado de pago y confirma para continuar.</small>
											</p>
											<div class="d-flex align-center justify-center" style="gap: 8px;">
												<v-btn color="#2D4B95" x-small dark class="action-btn"
													:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
													@click.stop="sendNewPaymentStatus">
													<v-icon left small>mdi-check</v-icon>
													<p class="mb-0 white--text">Confirmar</p>
												</v-btn>
												<v-btn text x-small style="height: auto;" @click="closeFormPS" class="action-btn-cancel">
													<v-icon left small color="error">mdi-close</v-icon>
													<p class="mb-0 error--text">Cancelar</p>
												</v-btn>
											</div>
										</div>
										<div v-else>
											<!-- Modo simplificado cuando sticky en desktop -->
											<template v-if="isHeaderSticky && !isMobile">
												<p class="caption font-weight-bold mb-0">Estado de Pago Nº{{ps.originalIndex + 1}}</p>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0 text--disabled">Estado Actual:</p>
													<div class="d-flex align-center" style="gap: 3px;">
														<p class="mb-0 caption font-weight-bold" :class="[statusColorClass(ps), 'status-text']">{{ ps.statustext }}</p>
														<p class="mb-0 caption font-weight-bold" :class="[statusColorClass(ps), 'status-text']" v-if="checkFullPayments(ps)">[Facturado]</p>
													</div>
												</div>
											</template>
											<!-- Modo completo (normal) -->
											<div class="sticky-collapsible" :class="{ 'is-hidden': isHeaderSticky && !isMobile }">
												<p class="caption font-weight-bold mb-0">Estado de Pago Nº{{ps.originalIndex + 1}}</p>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0 text--disabled">Estado Actual:</p>
													<div class="d-flex align-center" style="gap: 3px;">
														<p class="mb-0 caption font-weight-bold" :class="[statusColorClass(ps), 'status-text']">{{ ps.statustext }}</p>
														<p class="mb-0 caption font-weight-bold" :class="[statusColorClass(ps), 'status-text']" v-if="checkFullPayments(ps)">[Facturado]</p>
													</div>
												</div>
												<div class="d-flex align-center justify-space-between grey lighten-4" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0 text--disabled">Solicitado:</p>
													<p class="mb-0 caption font-weight-bold">{{ps.created_at | toDate}}</p>
												</div>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0 text--disabled">Aprobado:</p>
													<p class="mb-0 caption font-weight-bold"><span v-if="ps.approved_at">{{ps.approved_at | toDate}}</span><span v-else>--</span></p>
												</div>
												<div class="d-flex align-center justify-space-between grey lighten-4" style="gap: 5px;" v-if="ps.uf_value">
													<p class="caption font-weight-bold mb-0 text--disabled">Valor UF:</p>
													<p class="mb-0 caption font-weight-bold">${{ ps.uf_value?.uf_value | toThousandFilter(2) }}</p>
												</div>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0 text--disabled">Monto:</p>
													<p class="mb-0 caption font-weight-bold">{{prependToValue}}{{ps.total_sum | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0)}}</p>
												</div>
												<div class="d-flex align-center justify-space-between grey lighten-4" style="gap: 5px;" v-if="ps.payments?.length">
													<p class="caption font-weight-bold mb-0 text--disabled">Monto Facturado:</p>
													<p class="mb-0 caption font-weight-bold">{{prependToValue}}{{ps.payments_total | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0)}}</p>
												</div>
												<v-divider class="my-1"></v-divider>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0">Bitácora</p>
													<div class="d-flex align-center justify-end">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn
																	icon
																	dark
																	small
																	color="#2D4B95"
																	v-bind="attrs"
																	v-on="on"
																	@click="viewTarea(ps.id)">
																	<v-icon dark small>mdi-clipboard-text-outline</v-icon>
																</v-btn>
															</template>
															<span>Abre la tarea asociada al EP como Bitácora</span>
														</v-tooltip>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn
																	icon
																	dark
																	small
																	color="#2D4B95"
																	v-bind="attrs"
																	v-on="on"
																	:loading="loadingAgpsPdf"
																	@click.stop="downloadAgpsPDF(ps)">
																	<v-icon dark small>mdi-file-pdf-box</v-icon>
																</v-btn>
															</template>
															<span>Descargar PDF del Estado de Pago</span>
														</v-tooltip>
													</div>
												</div>
												<ParticipantsAgps :participants="ps.participants" :item="ps"/>
												<AGPPayments :item="ps" @reloadAdditionalInformativeTable="debouncedGetAdditionalInformativeTable" v-if="ps.status == additionalPaymentStatuses.APPROVED"/>
												<AGPFiles :item="ps" @filesUploaded="debouncedGetAdditionalInformativeTable"/>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;" v-if="isLastGeneratedPaymentStatus(ps, index)">
													<p class="caption font-weight-bold mb-0">Editar EP</p>
													<div class="d-flex align-center justify-end">
														<AGPSClosure
															:agps="ps"
															item_type="agps"
															:isUserIto="isUserIto"
															:editingPaymentStatusId="editingPaymentStatusId"
															@reloadInfo="debouncedGetAdditionalInformativeTable"
															@startEditPaymentStatus="startEditPaymentStatus"
															@closeEditPaymentStatus="closeEditPaymentStatus"/>
													</div>
												</div>
												<div v-if="editingPaymentStatusId === ps.id" class="d-flex flex-column mb-2" style="gap: 8px;">
													<p class="caption text-center mb-0" style="white-space: normal; word-wrap: break-word; line-height: 1.4;">Al confirmar el EP cambiará a estado <b>Modificado</b> y deberá ser aprobado por el ITO.</p>
													<v-btn color="#2D4B95" x-small dark class="action-btn"
														:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
														@click.stop="confirmEditPaymentStatus(ps)">
														<v-icon left small>mdi-check</v-icon>
														<p class="mb-0 white--text">Confirmar Edición del EP</p>
													</v-btn>
												</div>
												<div class="d-flex align-center justify-space-between" style="gap: 5px;">
													<p class="caption font-weight-bold mb-0">Filtrar adicionales en EP</p>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																icon small
																v-bind="attrs"
																v-on="on"
																:color="filteredByPaymentStatusId === ps.id ? '#2D4B95' : 'grey'"
																@click.stop="toggleFilterByPaymentStatus(ps.id)">
																<v-icon small>{{ filteredByPaymentStatusId === ps.id ? 'mdi-filter' : 'mdi-filter-outline' }}</v-icon>
															</v-btn>
														</template>
														<span>{{ filteredByPaymentStatusId === ps.id ? 'Quitar filtro de este EP' : 'Mostrar solo adicionales de este EP' }}</span>
													</v-tooltip>
												</div>
											</div>
											<v-divider class="my-1"></v-divider>
											<div v-if="![additionalPaymentStatuses.ITO_OBSERVED,additionalPaymentStatuses.APPROVED,additionalPaymentStatuses.CANCELLED,additionalPaymentStatuses.PAYED].includes(ps.status) && isUserIto">
												<!-- <p class="caption font-weight-bold mb-1 text--disabled">Acciones</p> -->
												<div class="d-flex" style="gap: 4px;" v-if="observingPaymentStatus == null">
													<v-btn outlined x-small color="error" class="flex-grow-1"
														@click="setStatusPaymentStatus(ps.id, 6)">
														<v-icon small left>mdi-close-box</v-icon>
														<span style="font-size: 10px; text-transform: none;">Rechazar</span>
													</v-btn>
													<v-btn outlined x-small color="orange" class="flex-grow-1"
														@click="observingPaymentStatus = index">
														<v-icon small left>mdi-alert-octagon</v-icon>
														<span style="font-size: 10px; text-transform: none;">Observar</span>
													</v-btn>
												</div>
												<div class="d-flex" style="gap: 4px;" v-else>
													<v-btn color="#2D4B95" class="flex-grow-1" x-small
														:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
														@click.stop="sendObservations">
														<v-icon small left>mdi-send</v-icon>
														<span style="font-size: 10px; text-transform: none;">Enviar observación</span>
													</v-btn>
													<v-btn outlined x-small color="error"
														@click="cancelObservations">
														<v-icon small>mdi-close-circle</v-icon>
													</v-btn>
												</div>
											</div>
											<div class="d-flex align-center" v-if="ps.status == additionalPaymentStatuses.ITO_OBSERVED && !isUserIto">
												<v-icon color="orange" small>mdi-information</v-icon>
												<p class="caption font-weight-bold ml-1 mb-0">Esperando Acción Constructora</p>
											</div>
											<div class="d-flex align-center" v-else-if="![additionalPaymentStatuses.ITO_OBSERVED,additionalPaymentStatuses.APPROVED,additionalPaymentStatuses.CANCELLED,additionalPaymentStatuses.PAYED].includes(ps.status) && !isUserIto">
												<v-icon color="orange" small>mdi-information</v-icon>
												<p class="caption font-weight-bold ml-1 mb-0">Esperando Acción ITO</p>
											</div>
											<div class="mt-1"
												v-if="![additionalPaymentStatuses.APPROVED,additionalPaymentStatuses.CANCELLED,additionalPaymentStatuses.PAYED].includes(ps.status)">
												<p class="caption font-weight-bold mb-1">Aprobación del EP</p>
												<AGPSApprovalClosure
													:ps="ps"
													:isUserIto="isUserIto"
													:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
													@onChange="debouncedGetAdditionalInformativeTable"
													@startApprove="startApprove"/>
											</div>
										</div>
									</v-col>

								</v-row>

								<!-- ===== MOBILE: selector de EP + detalle del EP seleccionado en el header ===== -->
								<div v-if="isMobile" class="mobile-ep-selector">
									<div v-if="reorderedPaymentStatuses.length > 0" class="pb-0">
										<p class="mb-1 caption font-weight-bold">Estado de Pago</p>
										<v-select
											v-model="selectedPaymentStatusIndex"
											:items="paymentStatusOptions"
											item-value="value"
											item-text="text"
											outlined
											dense
											hide-details
											class="caption"
										></v-select>
									</div>

									<!-- Detalle del EP seleccionado en mobile -->
									<div class="mt-2" v-if="selectedMobilePaymentStatus">
										<!-- Nuevo EP -->
										<div v-if="selectedMobilePaymentStatus.newPaymentStatus" class="new-payment-status-container mt-1">
											<div class="d-flex align-center justify-center" style="gap: 8px; margin-bottom: 8px;">
												<v-icon color="#2D4B95" small>mdi-plus-circle</v-icon>
												<p class="caption font-weight-bold mb-0">Nuevo Estado de Pago</p>
											</div>
											<p class="caption text--secondary mb-2" style="text-align: center; line-height: 1.3;">
												<small>Ingresa el avance en los adicionales que deseas incluir en este estado de pago y confirma para continuar.</small>
											</p>
											<div class="d-flex align-center justify-center" style="gap: 8px;">
												<v-btn color="#2D4B95" x-small dark class="action-btn"
													:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
													@click.stop="sendNewPaymentStatus">
													<v-icon left small>mdi-check</v-icon>
													<p class="mb-0 white--text">Confirmar</p>
												</v-btn>
												<v-btn text x-small style="height: auto;" @click="closeFormPS" class="action-btn-cancel">
													<v-icon left small color="error">mdi-close</v-icon>
													<p class="mb-0 error--text">Cancelar</p>
												</v-btn>
											</div>
										</div>

										<!-- EP existente: detalle -->
										<div v-else>
											<p class="caption font-weight-bold mb-0">Estado de Pago Nº{{ selectedMobilePaymentStatus.originalIndex + 1 }}</p>
											<div class="d-flex align-center justify-space-between" style="gap: 5px;">
												<p class="caption font-weight-bold mb-0 text--disabled">Estado Actual:</p>
												<div class="d-flex align-center" style="gap: 3px;">
													<p class="mb-0 caption font-weight-bold" :class="[statusColorClass(selectedMobilePaymentStatus), 'status-text']">{{ selectedMobilePaymentStatus.statustext }}</p>
													<p class="mb-0 caption font-weight-bold" :class="[statusColorClass(selectedMobilePaymentStatus), 'status-text']" v-if="checkFullPayments(selectedMobilePaymentStatus)">[Facturado]</p>
												</div>
											</div>
											<div class="d-flex align-center justify-space-between grey lighten-4" style="gap: 5px;">
												<p class="caption font-weight-bold mb-0 text--disabled">Solicitado:</p>
												<p class="mb-0 caption font-weight-bold">{{ selectedMobilePaymentStatus.created_at | toDate }}</p>
											</div>
											<div class="d-flex align-center justify-space-between" style="gap: 5px;">
												<p class="caption font-weight-bold mb-0 text--disabled">Aprobado:</p>
												<p class="mb-0 caption font-weight-bold">
													<span v-if="selectedMobilePaymentStatus.approved_at">{{ selectedMobilePaymentStatus.approved_at | toDate }}</span>
													<span v-else>--</span>
												</p>
											</div>
											<div class="d-flex align-center justify-space-between grey lighten-4" style="gap: 5px;" v-if="selectedMobilePaymentStatus.uf_value">
												<p class="caption font-weight-bold mb-0 text--disabled">Valor UF:</p>
												<p class="mb-0 caption font-weight-bold">${{ selectedMobilePaymentStatus.uf_value?.uf_value | toThousandFilter(2) }}</p>
											</div>
											<div class="d-flex align-center justify-space-between" style="gap: 5px;">
												<p class="caption font-weight-bold mb-0 text--disabled">Monto:</p>
												<p class="mb-0 caption font-weight-bold">{{ prependToValue }}{{ selectedMobilePaymentStatus.total_sum | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}</p>
											</div>
											<div class="d-flex align-center justify-space-between grey lighten-4" style="gap: 5px;" v-if="selectedMobilePaymentStatus.payments?.length">
												<p class="caption font-weight-bold mb-0 text--disabled">Monto Facturado:</p>
												<p class="mb-0 caption font-weight-bold">{{ prependToValue }}{{ selectedMobilePaymentStatus.payments_total | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}</p>
											</div>
											<div class="d-flex align-center justify-space-between" style="gap: 5px;">
												<p class="caption font-weight-bold mb-0">PDF del EP</p>
												<div class="d-flex align-center justify-end">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon dark small color="#2D4B95" v-bind="attrs" v-on="on"
																:loading="loadingAgpsPdf"
																@click.stop="downloadAgpsPDF(selectedMobilePaymentStatus)">
																<v-icon dark small>mdi-file-pdf-box</v-icon>
															</v-btn>
														</template>
														<span>Descargar PDF del Estado de Pago</span>
													</v-tooltip>
												</div>
											</div>
											<v-divider class="my-1"></v-divider>
											<ParticipantsAgps :participants="selectedMobilePaymentStatus.participants" :item="selectedMobilePaymentStatus"/>
											<AGPPayments :item="selectedMobilePaymentStatus" @reloadAdditionalInformativeTable="debouncedGetAdditionalInformativeTable" v-if="selectedMobilePaymentStatus.status == additionalPaymentStatuses.APPROVED"/>
											<AGPFiles :item="selectedMobilePaymentStatus" @filesUploaded="debouncedGetAdditionalInformativeTable"/>
											<div class="d-flex align-center justify-space-between" style="gap: 5px;" v-if="isLastGeneratedPaymentStatus(selectedMobilePaymentStatus, selectedPaymentStatusIndex)">
												<p class="caption font-weight-bold mb-0">Editar EP</p>
												<div class="d-flex align-center justify-end">
													<AGPSClosure
														:agps="selectedMobilePaymentStatus"
														item_type="agps"
														:isUserIto="isUserIto"
														:editingPaymentStatusId="editingPaymentStatusId"
														@reloadInfo="debouncedGetAdditionalInformativeTable"
														@startEditPaymentStatus="startEditPaymentStatus"
														@closeEditPaymentStatus="closeEditPaymentStatus"/>
												</div>
											</div>
											<div v-if="editingPaymentStatusId === selectedMobilePaymentStatus.id" class="d-flex flex-column mb-2" style="gap: 8px;">
												<p class="caption text-center mb-0" style="white-space: normal; word-wrap: break-word; line-height: 1.4;">Al confirmar el EP cambiará a estado <b>Modificado</b> y deberá ser aprobado por el ITO.</p>
												<v-btn color="#2D4B95" x-small dark class="action-btn"
													:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
													@click.stop="confirmEditPaymentStatus(selectedMobilePaymentStatus)">
													<v-icon left small>mdi-check</v-icon>
													<p class="mb-0 white--text">Confirmar Edición del EP</p>
												</v-btn>
											</div>
											<!-- ===== FILTRO POR EP (mobile) ===== -->
											<v-divider class="my-1"></v-divider>
											<div class="d-flex align-center justify-space-between" style="gap: 5px;">
												<p class="caption font-weight-bold mb-0">Filtrar adicionales</p>
												<v-btn
													x-small
													:text="filteredByPaymentStatusId !== selectedMobilePaymentStatus.id"
													:color="filteredByPaymentStatusId === selectedMobilePaymentStatus.id ? '#2D4B95' : 'grey'"
													:dark="filteredByPaymentStatusId === selectedMobilePaymentStatus.id"
													@click.stop="toggleFilterByPaymentStatus(selectedMobilePaymentStatus.id)">
													<v-icon small class="mr-1">{{ filteredByPaymentStatusId === selectedMobilePaymentStatus.id ? 'mdi-filter' : 'mdi-filter-outline' }}</v-icon>
													<span style="font-size: 10px; text-transform: none;">{{ filteredByPaymentStatusId === selectedMobilePaymentStatus.id ? 'Quitar filtro' : 'Solo este EP' }}</span>
												</v-btn>
											</div>
											<div v-if="![additionalPaymentStatuses.ITO_OBSERVED,additionalPaymentStatuses.APPROVED,additionalPaymentStatuses.CANCELLED,additionalPaymentStatuses.PAYED].includes(selectedMobilePaymentStatus.status) && isUserIto">
												<p class="caption font-weight-bold mb-1">Acciones</p>
												<div class="d-flex" style="gap: 4px;" v-if="observingPaymentStatus == null">
													<v-btn outlined x-small color="error" class="flex-grow-1"
														@click="setStatusPaymentStatus(selectedMobilePaymentStatus.id, 6)">
														<v-icon small left>mdi-close-box</v-icon>
														<span style="font-size: 10px; text-transform: none;">Rechazar</span>
													</v-btn>
													<v-btn outlined x-small color="orange" class="flex-grow-1"
														@click="observingPaymentStatus = selectedPaymentStatusIndex">
														<v-icon small left>mdi-alert-octagon</v-icon>
														<span style="font-size: 10px; text-transform: none;">Observar</span>
													</v-btn>
												</div>
												<div class="d-flex" style="gap: 4px;" v-else>
													<v-btn color="#2D4B95" class="flex-grow-1" x-small
														:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
														@click.stop="sendObservations">
														<v-icon small left>mdi-send</v-icon>
														<span style="font-size: 10px; text-transform: none;">Enviar observación</span>
													</v-btn>
													<v-btn outlined x-small color="error"
														@click="cancelObservations">
														<v-icon small>mdi-close-circle</v-icon>
													</v-btn>
												</div>
											</div>
											<div class="d-flex align-center" v-if="selectedMobilePaymentStatus.status == additionalPaymentStatuses.ITO_OBSERVED && !isUserIto">
												<v-icon color="orange" small>mdi-information</v-icon>
												<p class="caption font-weight-bold ml-1 mb-0">Esperando Acción Constructora</p>
											</div>
											<div class="d-flex align-center" v-else-if="![additionalPaymentStatuses.ITO_OBSERVED,additionalPaymentStatuses.APPROVED,additionalPaymentStatuses.CANCELLED,additionalPaymentStatuses.PAYED].includes(selectedMobilePaymentStatus.status) && !isUserIto">
												<v-icon color="orange" small>mdi-information</v-icon>
												<p class="caption font-weight-bold ml-1 mb-0">Esperando Acción ITO</p>
											</div>
											<AGPSApprovalClosure
												v-if="![additionalPaymentStatuses.APPROVED,additionalPaymentStatuses.CANCELLED,additionalPaymentStatuses.PAYED].includes(selectedMobilePaymentStatus.status)"
												:ps="selectedMobilePaymentStatus"
												:isUserIto="isUserIto"
												:loading="$store.adicionalesStore.state.listadoInformativeTable.status === 99 || loadingNewPS"
												@onChange="debouncedGetAdditionalInformativeTable"
												@startApprove="startApprove"/>
										</div>
									</div>
								</div>

							</div>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
			<v-progress-linear
				v-if="$store.adicionalesStore.state.listadoInformativeTable.status === 99"
				class="listing-loading-bar"
				indeterminate
				color="#5e85ef"
			></v-progress-linear>
		</v-card>
		<CreatePaymentStatusModal
			:value.sync="createPaymentStatusModalVisible"
			:additionals="additionalList"
			:selectedCurrency="selectedCurrency"
			@created="debouncedGetAdditionalInformativeTable"
		/>

		<!-- ===== AVISO DE FILTRO ACTIVO ===== -->
		<v-alert
			v-if="filteredByPaymentStatusId"
			type="warning"
			dense
			outlined
			class="mb-2 filter-active-alert"
			style="font-size: 12px;"
		>
			<div class="d-flex align-center justify-space-between flex-wrap" style="gap: 4px;">
				<div class="d-flex align-center" style="gap: 4px;">
					<v-icon small color="warning">mdi-filter</v-icon>
					<span>
						Mostrando solo los adicionales incluidos en el
						<strong>EP Nº{{ filteredPaymentStatusLabel }}</strong>.
						{{ filteredAdditionalCount }} adicional{{ filteredAdditionalCount !== 1 ? 'es' : '' }} visible{{ filteredAdditionalCount !== 1 ? 's' : '' }}.
					</span>
				</div>
				<v-btn x-small text color="warning" @click="filteredByPaymentStatusId = null" style="text-transform: none; font-weight: 600;">
					<v-icon x-small class="mr-1">mdi-close</v-icon>
					Quitar filtro
				</v-btn>
			</div>
		</v-alert>
		
		<div v-if="$store.adicionalesStore.state.listadoInformativeTable.status === 1 || $store.adicionalesStore.state.listadoInformativeTable.count > 0" class="listing-scroll">
			<v-card class="tarea-card mb-2" v-for="(additional, index) in filteredAdditionalList" :key="index"
				style="overflow: hidden;"
				@click.stop="viewAdditional(additional.id, $options.filters.seenByMe(additional.seen_by_me))">
				<v-card-text class="header-table-card py-2" :class="additional.status === 3 ? 'status-ended':''">
					<v-row align="center" :class="{ 'flex-nowrap': !isMobile }" class="overflow-auto" style="min-height: 100%; height: 100%;">
						<v-col :cols="isMobile ? 12 : 1">
							<div class="d-flex flex-column">
								<div class="d-flex flex-row icon-container">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="icon-top number" v-bind="attrs" v-on="on">
												<p class="mb-0 white--text text-task-number caption">{{additional.number}}</p>
											</div>
										</template>
										<span>Adicional número {{additional.number}}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="icon-top d-flex justify-center align-center" :class="$options.filters.seenByMeColor(additional.seen_by_me)"
												v-bind="attrs" v-on="on"
												@click.stop="changeVisualizationStatus(additional)">
												<v-icon color="white" :class="$options.filters.seenByMeIconAnimation(additional.seen_by_me)"
													v-if="!isLoadingChangeVisualizationStatus(additional.id)" small>mdi-bell</v-icon>
												<v-progress-circular v-else :width="2" :size="16" color="white" indeterminate></v-progress-circular>
											</div>
										</template>
										<span>{{$options.filters.seenByMeText(additional.seen_by_me)}} Adicional</span>
									</v-tooltip>
								</div>
							</div>
						</v-col>
						<v-col  :cols="isMobile ? 12 : 4">
							<div class="font-weight-bold additional-list-title caption mb-1" v-html="additional.title"></div>
							<div class="d-flex align-center" style="gap: 5px;">
								<p class="caption font-weight-bold mb-0 text--disabled">Tipo:</p>
								<p class="mb-0 caption font-weight-bold">{{getAdditionalType(additional.type)}} - {{getAdditionalCostType(additional.cost_type)}}</p>
							</div>
							<v-divider class="my-1"></v-divider>
							<div class="d-flex" style="gap: 5px;">
								<div class="flex-1 flex-grow-1" style="flex-basis: 50%; overflow: hidden; min-width: 0;">
									<div class="d-flex flex-row align-center justify-start">
										<div class="d-flex flex-column flex-grow-1">
											<p class="mb-0 body-2 text--secondary caption">
												<v-icon color="#2D4B95" class="mr-1" small>mdi-clipboard-edit-outline</v-icon>
												<span class="normal font-weight-bold">{{ additional.statustext }}</span>
											</p>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<div class="d-flex flex-row justify-start align-center" v-bind="attrs" v-on="on">
															<div class="d-flex flex-row align-center mr-1">
																<v-icon color="#2D4B95" class="mr-1" small>mdi-currency-usd</v-icon>
																<p class="mb-0 normal caption font-weight-bold">{{prependToValueAdditional(additional)}}{{additional.last_revision?.total_requested | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0)}}</p>
															</div>
														</div>
													</template>
													<span>{{additional.approved_status ? 'Monto Aprobado en última revisión. En moneda originalmente configurada.':'Monto Actual En moneda originalmente configurada.'}}</span>
												</v-tooltip>
											</div>
											<div v-if="informativeTableCurrencyInfo.id != additional.last_revision?.currency_info?.id">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<div class="d-flex flex-row justify-start align-center" style="opacity: 0.8;" v-bind="attrs" v-on="on">
															<div class="d-flex flex-row align-center mr-1">
																<v-icon color="grey" class="mr-1" small>mdi-currency-usd</v-icon>
																<p class="mb-0 caption font-weight-bold grey--text">{{prependToValue}}{{additional.last_revision?.total_requested_converted | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0)}}</p>
																<v-icon color="grey" class="ml-1" small>mdi-information-outline</v-icon>
															</div>
														</div>
													</template>
													<span>{{additional.approved_status ? 'Monto Aprobado en última revisión. Valor referencial.':'Monto Actual. Valor referencial.'}}</span>
												</v-tooltip>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<div class="d-flex flex-row justify-start align-center" v-bind="attrs" v-on="on">
															<div class="d-flex flex-row align-center mr-1">
																<v-icon color="#2D4B95" class="mr-1" small>mdi-calendar</v-icon>
																<p class="mb-0 normal caption font-weight-bold">{{additional.last_revision.created_at | toDate}}</p>
															</div>
														</div>
													</template>
													<span>Fecha Última Revisión</span>
												</v-tooltip>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<div class="d-flex flex-row justify-start align-center" v-if="additional.approved_status_change" v-bind="attrs" v-on="on">
															<div class="d-flex flex-row align-center mr-1">
																<v-icon color="#2D4B95" class="mr-1" small>mdi-calendar-check</v-icon>
																<p class="mb-0 normal caption font-weight-bold">{{additional.approved_status_change.created_at | toDate}}</p>
															</div>
														</div>
													</template>
													<span>Fecha Acuerdo</span>
												</v-tooltip>
											</div>
										</div>
									</div>
								</div>
								<v-divider vertical></v-divider>
								<div class="flex-1 flex-grow-1" style="flex-basis: 50%; overflow: hidden; min-width: 0;">
									<div class="caption" style="margin-right: 1px">
										<div class="d-flex flex-row align-center my-0 mr-1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div class="d-flex flex-row align-center mr-1" v-bind="attrs" v-on="on">
														<v-icon color="normal" class="mr-1" small>mdi-currency-usd</v-icon>
														<p class="mb-0 mr-2 normal font-weight-bold">{{prependToValue}}{{additional.total_amount_converted | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0)}}</p>
													</div>
												</template>
												<span>Monto total acumulado (aprobado)</span>
											</v-tooltip>
										</div>
										<div class="d-flex flex-row align-center my-0 mr-1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div class="d-flex flex-row align-center mr-1" v-bind="attrs" v-on="on">
														<v-icon color="medium" class="mr-1" small>mdi-currency-usd</v-icon>
														<p class="mb-0 mr-2 medium font-weight-bold">{{prependToValue}}{{(additional.last_revision?.total_requested_converted - additional.total_amount_converted) | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0)}}</p>
													</div>
												</template>
												<span>Saldo por pagar / aprobar (En relación al aprobado)</span>
											</v-tooltip>
										</div>
										<v-divider class="mt-1"></v-divider>
										<div>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<p class="mb-0 font-weight-bold" style="font-size: 10px;" v-bind="attrs" v-on="on">Avance Financiero</p>
												</template>
												<span>Porcentaje de avance de acuerdo a los adicionales aprobados</span>
											</v-tooltip>
											<v-progress-linear :value="additional.total_progress*100" color="primary" height="10" rounded>
												<p class="mb-0" style="font-size: 9px;" :class="additional.total_progress < 0.43 ? '':'white--text'">{{ Math.round(additional.total_progress*100) }}%</p>
											</v-progress-linear>
										</div>
										<div>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<p class="mb-0 font-weight-bold" style="font-size: 10px;" v-bind="attrs" v-on="on">
														Avance Físico (<span v-if="additional.last_progress">{{ additional.last_progress.updated_at | toDate }}</span><span v-else>--</span>)
													</p>
												</template>
												<span>Último porcentaje de avance físico informado</span>
											</v-tooltip>
											<div class="d-flex align-center">
												<v-progress-linear
													v-if="additional.last_progress && edittingAdditionalProgressId != additional.id"
													:value="additional.last_progress.physical_progress*100"
													color="primary" height="10" rounded>
													<p class="mb-0" style="font-size: 9px;" :class="additional.last_progress.physical_progress < 0.43 ? '':'white--text'">{{ Math.round(additional.last_progress.physical_progress*100) }}%</p>
												</v-progress-linear>
												<div class="flex-grow-1" v-else-if="edittingAdditionalProgressId != additional.id">
													<p class="mb-0 caption">No informado</p>
												</div>
												<div v-if="edittingAdditionalProgressId == additional.id" class="ml-2 d-flex align-center flex-grow-1" @click.stop>
													<v-text-field
														v-model="additionalProgressValue"
														placeholder="% Avance"
														type="number"
														:max="edittingAdditionalCostType === 1 ? 100 : undefined"
														min="0"
														outlined dense hide-details
														:height="20"
														class="custom-input-numbers text-center">
													</v-text-field>
													<div class="d-flex align-center ml-1">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn color="red" icon x-small v-bind="attrs" v-on="on" @click.stop="startEditAdditionalProgress(null)">
																	<v-icon small>mdi-window-close</v-icon>
																</v-btn>
															</template>
															<span>Cancelar</span>
														</v-tooltip>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn color="green" icon x-small v-bind="attrs" v-on="on" @click.stop="confirmEditProgress">
																	<v-icon small>mdi-check</v-icon>
																</v-btn>
															</template>
															<span>Confirmar</span>
														</v-tooltip>
													</div>
												</div>
												<v-btn color="#2D4B95" icon small v-else @click.stop="startEditAdditionalProgress(additional.id, additional.cost_type)">
													<v-icon color="normal">mdi-pencil-box-outline</v-icon>
												</v-btn>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-col>
						<v-col :cols="isMobile ? 12 : 7">
							<!-- DESKTOP: scroll horizontal por fila (sin cambios) -->
							<v-row v-if="!isMobile"
								ref="scrollContainer"
								class="d-flex flex-nowrap"
								align="stretch"
								style="overflow-x: auto; white-space: nowrap; height: 100%; min-height: 100%;">
								<v-col
									cols="auto"
									class="pa-0 d-flex align-center justify-center"
									:class="{ 'custom-first-row-payment-status': index === 0 }"
									v-for="(ps, index) in displayedPaymentStatuses"
									:key="index"
									style="min-width: 250px;">
									<NewPaymentStatusAdditionalForm
										v-if="ps.newPaymentStatus || editingPaymentStatusId === ps.id"
										:ps="ps"
										:additional="additional"
										:closeForm="() => closeEditPaymentStatus()"
										:onChangeProgress="(value) => {onChangeProgress(value, additional)}"
									/>
									<ObservationPaymentStatusAdditionalForm
										v-else-if="observingPaymentStatus == index"
										:additional="additional"
										:additional_included="ps.additional_included"
										:closeForm="() => observingPaymentStatus = null"
										:onChangeProgress="(value) => {onChangeProgressObservation(value, additional)}"
									/>
									<AdditionalPaymentStatusIncluded
										v-else
										:additional="additional"
										:additional_included="ps.additional_included"
										:disabled="loading"
									/>
								</v-col>
							</v-row>

							<!-- MOBILE: mostrar solo la columna del EP seleccionado -->
							<div v-else style="width: 100%;" @click.stop>
								<template v-if="selectedMobilePaymentStatus">
									<NewPaymentStatusAdditionalForm
										v-if="selectedMobilePaymentStatus.newPaymentStatus || editingPaymentStatusId === selectedMobilePaymentStatus.id"
										:ps="selectedMobilePaymentStatus"
										:additional="additional"
										:closeForm="() => closeEditPaymentStatus()"
										:onChangeProgress="(value) => {onChangeProgress(value, additional)}"
									/>
									<ObservationPaymentStatusAdditionalForm
										v-else-if="observingPaymentStatus == selectedPaymentStatusIndex"
										:additional="additional"
										:additional_included="selectedMobilePaymentStatus.additional_included"
										:closeForm="() => observingPaymentStatus = null"
										:onChangeProgress="(value) => {onChangeProgressObservation(value, additional)}"
									/>
									<AdditionalPaymentStatusIncluded
										v-else
										:additional="additional"
										:additional_included="selectedMobilePaymentStatus.additional_included"
										:disabled="loading"
									/>
								</template>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
			<v-row align="center">
				<v-col cols="12">
					<v-pagination
						v-model="page"
						color="#2D4B95"
						:length="Math.ceil($store.rdiStore.state.listadoRDITotal/50)"
						:total-visible="7"
						@input="changePage"
					></v-pagination>
				</v-col>
			</v-row>
		</div>
		<div v-else>
			<v-card class="mb-2 py-2" v-for="i in 5" :key="i">
				<v-card-text class="py-2">
					<v-row>
						<v-col cols="1">
							<div class="d-flex flex-row">
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="2">
							<div>
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="4">
							<div class="d-flex flex-row justify-center align-center">
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="2">
							<div>
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="3">
							<div>
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item"></v-skeleton-loader>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</div>
		<AcceptCancelModal
			:acceptRejectModal="acceptRejectModal"
			:acceptRejectModalData="acceptRejectModalData"
			:closeModal="closeModalAcceptCancel"/>
	</v-container>
</template>

<script>
import moment from 'moment'
import NewPaymentStatusAdditionalForm from './Parts/NewPaymentStatusAdditionalForm'
import ObservationPaymentStatusAdditionalForm from './Parts/ObservationPaymentStatusAdditionalForm.vue'
import AdditionalPaymentStatusIncluded from './Parts/AdditionalPaymentStatusIncluded.vue'
import AcceptCancelModal from '@/components/Globals/Modals/General/AcceptCancelModal'
import ParticipantsAgps from './Parts/ParticipantsAgps'
import AGPPayments from './Parts/AGPPayments'
import AGPFiles from './Parts/AGPFiles'
import ProjectDetailCard from '@/components/Views/Home/ProjectDetails/Widgets/ProjectDetailCard'
import AdditionalsSimpleSummary from '@/components/Views/Adicionales/Parts/AdditionalsSimpleSummary'
import CreatePaymentStatusModal from '@/components/Globals/Modals/Adicionales/CreatePaymentStatusModal'
import {changeVisualizationStatus, newPaymentStatus, editPaymentStatus, newPaymentStatusInteraction, setStatusToAgps, createAdditionalProgress, exportCombinedAdditionalData, getTareaAgpAssociation, getAgpsPDF} from '@/helpers/api/additionals'
import {additionalPaymentStatuses} from '@/helpers/constants/additional'
import { getDashboardInfo } from '@/helpers/api/dashboard'
import _debounce from 'lodash/debounce'
import EventBus from '@/helpers/event_bus'
import AGPSClosure from '@/components/Views/Adicionales/Parts/AGPSClosure'
import AGPSApprovalClosure from '@/components/Views/Adicionales/Parts/AGPSApprovalClosure'

export default {
	name: 'TablaInformativaAdicionales',
	components: {AdditionalPaymentStatusIncluded, NewPaymentStatusAdditionalForm, ObservationPaymentStatusAdditionalForm, ParticipantsAgps, AcceptCancelModal, AGPPayments, AGPFiles, AGPSClosure, AGPSApprovalClosure, ProjectDetailCard, AdditionalsSimpleSummary, CreatePaymentStatusModal},
	props: {
		ended: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		additionalList() {
			return this.$store.adicionalesStore.state.listadoInformativeTable?.data || []
		},
		// Lista filtrada por EP activo (o lista completa si no hay filtro)
		filteredAdditionalList() {
			if (!this.filteredByPaymentStatusId) return this.additionalList
			const ps = (this.$store.adicionalesStore.state.listadoInformativeTable?.payment_statuses || [])
				.find(p => p.id === this.filteredByPaymentStatusId)
			if (!ps) return this.additionalList
			const includedIds = new Set((ps.additional_included || []).map(a => a.additional_id))
			return this.additionalList.filter(a => includedIds.has(a.id))
		},
		// Número del EP filtrado (1-based, usando originalIndex)
		filteredPaymentStatusLabel() {
			const statuses = this.$store.adicionalesStore.state.listadoInformativeTable?.payment_statuses || []
			const idx = statuses.findIndex(p => p.id === this.filteredByPaymentStatusId)
			return idx !== -1 ? idx + 1 : '?'
		},
		// Cantidad de adicionales visibles con el filtro activo
		filteredAdditionalCount() {
			return this.filteredAdditionalList.length
		},
		isMobile() {
			return this.$vuetify.breakpoint.mobile
		},
		prependToValue() {
			const code = this.informativeTableCurrencyInfo?.code || 'CLP'
			const symbol = this.informativeTableCurrencyInfo?.symbol || '$'
			if (code != symbol) {
				return `${code} ${symbol}`
			}
			return code
		},
		isUserIto() {
			return this.$store.projectsStore.state.selectedProject.job_type.id == 4
		},
		informativeTableCurrencyInfo() {
			return this.$store.adicionalesStore.state.listadoInformativeTable.currency_info || {}
		},
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		paymentStatuses() {
			return this.$store.adicionalesStore.state.listadoInformativeTable.payment_statuses
		},
		canCreateNewPaymentStatus() {
			if (!this.checkPermissions(['add_payment_status_additionals'])) { return false }
			const paymentStatuses = this.$store.adicionalesStore.state.listadoInformativeTable.payment_statuses;
			if (!paymentStatuses || paymentStatuses.length === 0) return true;
			const lastStatus = paymentStatuses[paymentStatuses.length - 1].status;
			return [
				additionalPaymentStatuses.APPROVED,
				additionalPaymentStatuses.CANCELLED,
				additionalPaymentStatuses.REJECTED,
				additionalPaymentStatuses.PAYED
			].includes(lastStatus);
		},
		reorderedPaymentStatuses() {
			const statuses = this.$store.adicionalesStore.state.listadoInformativeTable.payment_statuses || [];
			const statusesWithIndex = statuses.map((s, idx) => ({
				...s,
				originalIndex: idx
			}));
			const lastStatus = statusesWithIndex[statusesWithIndex.length - 1];
			const otherStatuses = statusesWithIndex.slice(0, -1);
			const all_statuses = this.newPaymentStatus
				? [{ newPaymentStatus: true }, ...otherStatuses, lastStatus]
				: [lastStatus, ...otherStatuses];
			console.log('Reordered Payment Statuses:', all_statuses);
			return all_statuses;
		},
		// Desktop: siempre todos los EP (scroll horizontal)
		displayedPaymentStatuses() {
			return this.reorderedPaymentStatuses
		},
		// Mobile: EP actualmente seleccionado
		selectedMobilePaymentStatus() {
			return this.reorderedPaymentStatuses[this.selectedPaymentStatusIndex] || null
		},
		paymentStatusOptions() {
			return this.reorderedPaymentStatuses.map((ps, index) => ({
				value: index,
				text: ps?.newPaymentStatus
					? 'Nuevo Estado de Pago'
					: `EP Nº${(ps?.originalIndex ?? index) + 1} — ${ps?.statustext || ''}`
			}))
		}
	},
	watch: {
		paymentStatuses: {
			handler() {
				this.scrollToEnd();
				// Al recargar datos, resetear selección mobile al último EP (índice 0 en reorderedPaymentStatuses)
				this.selectedPaymentStatusIndex = 0;
				// Si el EP filtrado ya no existe, limpiar el filtro
				if (this.filteredByPaymentStatusId) {
					const stillExists = (this.$store.adicionalesStore.state.listadoInformativeTable?.payment_statuses || [])
						.some(p => p.id === this.filteredByPaymentStatusId)
					if (!stillExists) this.filteredByPaymentStatusId = null
				}
			},
			deep: true
		},
		newPaymentStatus(val) {
			this.scrollToEnd();
			// Si se crea un nuevo EP en mobile, seleccionarlo automáticamente (queda en índice 0)
			if (val && this.isMobile) {
				this.selectedPaymentStatusIndex = 0;
			}
		},
		selectedProject(newData) {
			if (newData) {
				this.getProjectSubjects()
				this.getGraphInfo()
			}
		}
	},
	data: () => ({
		additionalPaymentStatuses,
		// Índice 0 = último EP en reorderedPaymentStatuses (o "nuevo EP" si está activo)
		selectedPaymentStatusIndex: 0,
		// ID del EP por el que se filtra el listado de adicionales (null = sin filtro)
		filteredByPaymentStatusId: null,
		edittingAdditionalProgressId: null,
		edittingAdditionalCostType: null,
		additionalProgressValue: null,
		loading: false,
		specialtyFilter: [],
		specialtyMenu: false,
		subjectFilter: [],
		subjectMenu: false,
		responsableFilter: [],
		responsableMenu: false,
		estadoMenu: false,
		estadoFilter: [1, 2, 3, 4],
		page: 1,
		showRevDetails: false,
		newPaymentStatus: false,
		createPaymentStatusModalVisible: false,
		newPaymentStatusData: [],
		loadingNewPS: false,
		observingPaymentStatus: null,
		observationsArray: [],
		isSyncingScroll: false,
		scrollObserver: null,
		acceptRejectModal: false,
		acceptRejectModalData: null,
		editingPaymentStatusId: null,
		graphInfo: null,
		debouncedGetAdditionalInformativeTable: () => {},
		selectedCurrency: 2,
		currencyOptions: [
			{ id: 1, label: 'USD - Dólar Americano', code: 'USD' },
			{ id: 2, label: 'CLP - Pesos Chilenos', code: 'CLP' },
			{ id: 3, label: 'UF - Unidad de Fomento', code: 'UF' }
		],
		summaryInfoType: 2,
		showCurrencyAlert: true,
		isHeaderSticky: false,
		headerStickyObserver: null,
		loadingAgpsPdf: false,
	}),
	beforeDestroy() {
		if (this.scrollObserver) {
			this.scrollObserver.disconnect();
		}
		if (this.headerStickyObserver) {
			this.headerStickyObserver.disconnect();
		}
		if (this._stickyScrollHandler) {
			window.removeEventListener('scroll', this._stickyScrollHandler)
		}
		EventBus.$off('reloadInformativeTable')
		EventBus.$off('completedFileUpload')
	},
	mounted() {
		this.debouncedGetAdditionalInformativeTable = _debounce(this.getAdditionalInformativeTable, 500)
		this.setListeners()

		if(this.selectedProject.id){
			this.getGraphInfo()
			if (this.$store.projectsStore.state.projectSubjects.length == 0) {
				this.getProjectSubjects()
			}
		}

		// Sync de scroll solo aplica en desktop
		this.scrollObserver = new MutationObserver(() => {
			if (this.isMobile) return;
			const header = this.$refs.scrollHeaderContainer?.$el || this.$refs.scrollHeaderContainer;
			const bodies = (this.$refs.scrollContainer || []).map(el => el?.$el || el);
			if (header && bodies.length > 0) {
				header.removeEventListener('scroll', this.syncScrollFromHeader);
				header.addEventListener('scroll', this.syncScrollFromHeader);
				bodies.forEach(body => {
					body.removeEventListener('scroll', this.syncScrollFromBody);
					body.addEventListener('scroll', this.syncScrollFromBody);
				});
				this.scrollObserver.disconnect();
			}
		});
		this.scrollObserver.observe(this.$el, { childList: true, subtree: true });

		if (!this.isMobile) {
			this._stickyScrollHandler = () => {
				const scrollY = window.scrollY || document.documentElement.scrollTop
				if (!this.isHeaderSticky && scrollY > 10) {
					this.isHeaderSticky = true
				} else if (this.isHeaderSticky && scrollY < 5) {
					this.isHeaderSticky = false
				}
			}
			window.addEventListener('scroll', this._stickyScrollHandler, { passive: true })
		}
	},
	methods: {
		// Alterna el filtro por EP: si ya estaba activo para ese EP, lo desactiva
		toggleFilterByPaymentStatus(psId) {
			this.filteredByPaymentStatusId = this.filteredByPaymentStatusId === psId ? null : psId
		},
		async getGraphInfo(){
			const data = {
				project_id: this.selectedProject.id
			}
			const response = await getDashboardInfo(data)
			if(response.code == 200){
				this.graphInfo = response.data
			}
		},
		async viewTarea(agps_id){
			const tarea = await getTareaAgpAssociation({agps_id})
			if(tarea.code === 200){
				this.$store.consultasStore.commit('setCurrentTarea', tarea.task)
			}
		},
		async downloadAgpsPDF(ps) {
			this.loadingAgpsPdf = true
			try {
				const resp = await getAgpsPDF({ agps_id: ps.id, currency_id: this.selectedCurrency })
				if (resp.code == 200) {
					window.open(resp.pdf_url, '_blank')
				}
			} catch(e) {
				console.error(e)
			} finally {
				this.loadingAgpsPdf = false
			}
		},
		getAdditionalType(additionalType){
			const found = this.$store.adicionalesStore.state.additionalTypes.find(type => type.id === additionalType)
			if(found){
				return found.name
			}
			return '--'
		},
		getAdditionalCostType(additionalType){
			const found = this.$store.adicionalesStore.state.additionalCostTypes.find(type => type.id === additionalType)
			if(found){
				return found.name
			}
			return '--'
		},
		prependToValueAdditional(additional) {
			const code = additional?.last_revision?.currency_info?.code || 'CLP'
			const symbol = additional?.last_revision?.currency_info?.symbol || '$'
			if (code != 'UF') {
				return `${code} ${symbol}`
			}
			return `${code} `
		},
		onCurrencyChange() {
			this.getAdditionalInformativeTable()
		},
		setListeners() {
			EventBus.$on('completedFileUpload', async (payload) => {
				if (payload?.from_file_upload_to_ps) {
					this.debouncedGetAdditionalInformativeTable()
				}
			})
			EventBus.$on('reloadInformativeTable', async () => {
				this.debouncedGetAdditionalInformativeTable()
			})
		},
		approvalStatusCheck(ps) {
			const has_jefe_ot = ps.approval_checks.some(check => check.job_type == 2)
			const has_ito = ps.approval_checks.some(check => check.job_type == 4)
			return has_jefe_ot && has_ito
		},
		isLastGeneratedPaymentStatus(ps, index) {
			if (ps.newPaymentStatus) return false;
			const reordered = this.reorderedPaymentStatuses;
			const hasNewPaymentStatus = reordered[0]?.newPaymentStatus;
			if (hasNewPaymentStatus) {
				return index === reordered.length - 1;
			} else {
				return index === 0;
			}
		},
		checkFullPayments(ps) {
			const totalPayed = this.getTotalPayed(ps)
			return totalPayed >= ps.total_sum
		},
		getTotalPayed(ps) {
			return ps.payments.reduce((total, payment) => {
				return total + payment.amount
			}, 0)
		},
		async confirmEditProgress() {
			if (this.additionalProgressValue === null || this.additionalProgressValue === '' || this.edittingAdditionalProgressId === null) {
				return
			}
			if (this.edittingAdditionalCostType === 1 && parseFloat(this.additionalProgressValue) > 100) {
				return
			}
			const data = {
				additional_id: this.edittingAdditionalProgressId,
				physical_progress: +parseFloat(this.additionalProgressValue) / 100
			}
			const response = await createAdditionalProgress(data)
			if (response.code == 200) {
				this.edittingAdditionalProgressId = null
				this.additionalProgressValue = null
				this.debouncedGetAdditionalInformativeTable()
			}
		},
		startEditAdditionalProgress(additionalId, costType = null) {
			this.additionalProgressValue = null
			if (this.edittingAdditionalProgressId == additionalId) {
				this.edittingAdditionalProgressId = null
				this.edittingAdditionalCostType = null
			} else {
				this.edittingAdditionalProgressId = additionalId
				this.edittingAdditionalCostType = costType
			}
		},
		closeModalAcceptCancel(status = false) {
			this.acceptRejectModal = false
			if (status) {
				this.setStatusPaymentStatus(this.acceptRejectModalData.ps_id, this.acceptRejectModalData.status)
			}
			this.acceptRejectModalData = null
		},
		startApprove(ps) {
			this.acceptRejectModalData = {
				title: '¿Quieres aprobar el Estado de Pago Nº' + (ps.originalIndex + 1) + '?',
				content_a: 'Por favor confirma si deseas aprobar este estado de pago.',
				ps_id: ps.id,
				status: 4
			}
			this.acceptRejectModal = true
		},
		syncScrollFromHeader(e) {
			if (this.isSyncingScroll) return;
			this.isSyncingScroll = true;
			const scrollLeft = e.target.scrollLeft;
			(this.$refs.scrollContainer || []).forEach(container => {
				const el = container?.$el || container;
				if (el && el.scrollLeft !== scrollLeft) {
					el.scrollLeft = scrollLeft;
				}
			});
			this.isSyncingScroll = false;
		},
		syncScrollFromBody(e) {
			if (this.isSyncingScroll) return;
			this.isSyncingScroll = true;
			const scrollLeft = e.target.scrollLeft;
			const header = this.$refs.scrollHeaderContainer?.$el || this.$refs.scrollHeaderContainer;
			if (header && header.scrollLeft !== scrollLeft) {
				header.scrollLeft = scrollLeft;
			}
			this.isSyncingScroll = false;
		},
		scrollToEnd() {
			if (this.isMobile) return;
			this.$nextTick(() => {
				if (this.$refs.scrollContainer) {
					const containers = this.$refs.scrollContainer
					containers.forEach(container => {
						container.scrollLeft = container.scrollWidth
					})
				}
				if (this.$refs.scrollHeaderContainer) {
					const headerContainer = this.$refs.scrollHeaderContainer
					headerContainer.scrollLeft = headerContainer.scrollWidth
				}
			});
		},
		paymentStatusTotal(paymentStatusIncluded) {
			return paymentStatusIncluded.reduce(
				(accumulator, currentValue) => accumulator + currentValue.amount,
				0
			)
		},
		async setStatusPaymentStatus(paymentStatusId, status) {
			this.loading = true
			const data = {
				additional_global_payment_status_id: paymentStatusId,
				status
			}
			await setStatusToAgps(data)
			this.debouncedGetAdditionalInformativeTable()
			this.loading = false
		},
		async sendNewPaymentStatus() {
			this.loadingNewPS = true
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				additionals_included: this.newPaymentStatusData
			}
			try {
				await newPaymentStatus(data)
				this.newPaymentStatus = false
				this.newPaymentStatusData = []
				this.debouncedGetAdditionalInformativeTable()
			} catch (error) {
				const datas = {
					message: 'Hubo un error al crear el estado de pago. Por favor intenta nuevamente.',
					title: 'Error',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				}
				this.$store.globalStore.dispatch('addMessage', datas)
			}
			this.loadingNewPS = false
		},
		async confirmEditPaymentStatus(ps) {
			if (this.newPaymentStatusData.length === 0) {
				this.newPaymentStatusData = ps.additional_included.map(item => ({
					additional_id: item.additional_id,
					progress: item.progress,
					amount: item.amount
				}))
			}
			this.loadingNewPS = true
			const data = {
				agps_id: ps.id,
				project_id: this.$store.projectsStore.state.selectedProject.id,
				additionals_included: this.newPaymentStatusData
			}
			try {
				await editPaymentStatus(data)
				this.editingPaymentStatusId = null
				this.newPaymentStatusData = []
				this.debouncedGetAdditionalInformativeTable()
			} catch (error) {
				const datas = {
					message: 'Hubo un error al editar el estado de pago. Por favor intenta nuevamente.',
					title: 'Error',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				}
				this.$store.globalStore.dispatch('addMessage', datas)
			}
			this.loadingNewPS = false
		},
		onChangeProgress(value, additional) {
			if (!value) {
				const foundIndex = this.newPaymentStatusData.findIndex((ps) => {
					return ps.additional_id == additional.id
				})
				if (foundIndex != -1) {
					this.newPaymentStatusData.splice(foundIndex, 1)
				}
				return
			}
			const amount = +parseFloat(additional.last_revision.total_requested * value / 100).toFixed(2);
			const data = {
				additional_id: additional.id,
				progress: value / 100,
				amount
			}
			const foundIndex = this.newPaymentStatusData.findIndex((ps) => {
				return ps.additional_id == additional.id
			})
			let newArray = [...this.newPaymentStatusData]
			if (foundIndex != -1) {
				newArray[foundIndex] = data
			} else {
				newArray.push(data)
			}
			this.newPaymentStatusData = newArray
		},
		onChangeProgressObservation(value) {
			const foundIndex = this.observationsArray.findIndex((obs) => {
				return obs.additional_payment_status_id == value.additional_payment_status_id
			})
			if (foundIndex != -1) {
				let newArray = [...this.observationsArray]
				newArray[foundIndex] = value
				this.observationsArray = newArray
			} else {
				this.observationsArray.push(value)
			}
		},
		cancelObservations() {
			this.observingPaymentStatus = null
			this.observationsArray = []
		},
		async sendObservations() {
			if (this.observationsArray && this.observationsArray.length > 0) {
				this.loading = true;
				await Promise.all(
					this.observationsArray.map(data => newPaymentStatusInteraction(data))
				);
				this.debouncedGetAdditionalInformativeTable();
				this.cancelObservations();
				this.loading = false;
			}
		},
		addPaymentStatus() {
			this.createPaymentStatusModalVisible = true
		},
		closeFormPS() {
			this.newPaymentStatus = false
			this.newPaymentStatusData = []
		},
		startEditPaymentStatus(ps) {
			this.editingPaymentStatusId = ps.id
		},
		closeEditPaymentStatus() {
			this.editingPaymentStatusId = null
			this.newPaymentStatus = false
			this.newPaymentStatusData = []
		},
		statusColorClass(additional) {
			if ([additionalPaymentStatuses.APPROVED, additionalPaymentStatuses.PAYED].includes(additional.status)) { return 'normal' }
			else if ([additionalPaymentStatuses.REQUESTED, additionalPaymentStatuses.ITO_OBSERVED, additionalPaymentStatuses.CONST_OBSERVED].includes(additional.status)) { return 'medium' }
			return 'high'
		},
		revsDetailsData(additionalData) {
			if (this.showRevDetails) {
				return additionalData.revisions ? additionalData.revisions : []
			}
			return []
		},
		async changeVisualizationStatus(rdi) {
			if (!this.isLoadingChangeVisualizationStatus(rdi.id)) {
				let newStatus = 0
				if (!rdi.seen_by_me) {
					newStatus = 1
				} else if (rdi.seen_by_me.seen_status < 2) {
					newStatus = rdi.seen_by_me.seen_status + 1
				} else if (rdi.seen_by_me.seen_status === 2) {
					newStatus = 0
				}
				this.$store.rdiStore.commit('addLoadingChangeVisualizationStatus', rdi.id)
				const data = {
					rdi_id: rdi.id,
					status: newStatus
				}
				const statusUpdate = await changeVisualizationStatus(data)
				if (statusUpdate.code === 200) {
					rdi.seen_by_me.seen_status = newStatus
				}
				this.$store.rdiStore.commit('removeLoadingChangeVisualizationStatus', rdi.id)
			}
		},
		isLoadingChangeVisualizationStatus(rdiID) {
			const found = this.$store.rdiStore.state.loadingChangeVisualizationStatus.find((rdi_id) => rdi_id === rdiID)
			return found
		},
		clearFilters() {
			this.creatorFilter = []
			this.responsableFilter = []
		},
		async getProjectSubjects() {
			if (this.$store.projectsStore.state.selectedProject && this.$store.projectsStore.state.selectedProject.id) {
				this.$store.projectsStore.dispatch('getProjectSubjects', this.$store.projectsStore.state.selectedProject.id)
			}
		},
		getIconOrder() {
			if (this.$store.rdiStore.state.listingOrder === 1 || this.$store.rdiStore.state.listingOrder === 3) {
				return 'mdi-arrow-down-bold'
			} else if (this.$store.rdiStore.state.listingOrder === 2 || this.$store.rdiStore.state.listingOrder === 4) {
				return 'mdi-arrow-up-bold'
			}
			return 'mdi-swap-vertical-bold'
		},
		toggleOrder() {
			this.$store.rdiStore.commit('setListingOrder')
			this.debouncedGetAdditionalInformativeTable()
		},
		getNameOrder() {
			if (this.$store.rdiStore.state.listingOrder === 1 || this.$store.rdiStore.state.listingOrder === 2) {
				return 'Prioridad'
			} else if (this.$store.rdiStore.state.listingOrder === 3 || this.$store.rdiStore.state.listingOrder === 4) {
				return 'Número'
			}
		},
		async getAdditionalInformativeTable() {
			let project_id = null
			const page = this.page
			if (this.$store.projectsStore.state.selectedProject) {
				project_id = this.$store.projectsStore.state.selectedProject.id
			} else {
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if (project_id) {
				this.$store.adicionalesStore.dispatch('getAdditionalInformativeTable', {
					project_id, page,
					currency_id: this.selectedCurrency,
					statuses: this.estadoFilter,
					filtered_specialties: this.specialtyFilter,
					filtered_responsable: this.responsableFilter
				})
			}
		},
		getTareaPriorityText(rdi) {
			if (rdi.priority === 3) { return 'Inmediata' }
			else if (rdi.priority === 2) { return 'Media' }
			return 'Estándar'
		},
		checkIfNearDeadline(rdi) {
			if (!rdi.critical_date) { return false }
			const now = moment()
			const rdi_date = moment(rdi.critical_date)
			return rdi_date.diff(now, 'days') <= 2
		},
		setLights(data) {
			return require('@/assets/Svg/VistaListado/Semaforo' + data + '.svg')
		},
		filterList() {
			this.debouncedGetAdditionalInformativeTable()
			this.specialtyMenu = false
			this.subjectMenu = false
			this.responsableMenu = false
		},
		async viewAdditional(additional_id, seen_by_me) {
			this.$store.adicionalesStore.dispatch('getAdditionalByID', { additional_id, seen_by_me })
		},
		changePage() {
			this.debouncedGetAdditionalInformativeTable()
		},
		responseStatus(rdi) {
			if (rdi.response_status == 1) {
				return this.$store.projectsStore.state.selectedProject && this.$store.projectsStore.state.selectedProject.job_type && this.$store.projectsStore.state.selectedProject.job_type.id == 4
			} else if (rdi.response_status == 2) {
				return this.$store.projectsStore.state.selectedProject && this.$store.projectsStore.state.selectedProject.job_type && this.$store.projectsStore.state.selectedProject.job_type.id != 4
			}
			return false
		},
		async combinedExportExcel(target_currency_id) {
			this.loadingExport = true
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				target_currency_id
			}
			const exportAdditionals = await exportCombinedAdditionalData(data)
			if (exportAdditionals.code == 200) {
				window.open(exportAdditionals.url);
			}
			this.loadingExport = false
		}
	}
};
</script>

<style scoped>
	#listado-consultas { align-self: stretch; }
	.text-primary-color { color: #2D4B95; }
	.light-blue-text { color: #5E85EF; }
	.bg-normal { background-color: #3EBFA3; }
	.inner-text { font-size: 10px; }
	.status-container { position: relative; }
	.icon-top.icon-status {
		position: absolute;
		width: 20px;
		height: 20px;
		left: -20px;
	}
	.icon-top {
		padding: 2px;
		margin: 0 2px;
		border-radius: 100%;
	}
	.high { color: #F4516C; }
	.medium { color: #fb8c00; }
	.normal { color: #3EBFA3; }
	.bg-high, .icon-top.high { background-color: #F4516C; }
	.bg-medium, .icon-top.medium { background-color: #fb8c00; }
	.bg-normal, .icon-top.normal { background-color: #3EBFA3; }
	.icon-top.primary { background-color: #2D4B95; }
	.icon-top.light-blue { background-color: #5E85EF; }
	.counter-tareas {
		background-color: #F4516C;
		border-radius: 100%;
		padding: 5px;
		width: 30px;
		height: 30px;
		line-height: 20px;
		color: white;
		font-size: 20px;
		text-align: center;
	}
	.status-icon {
		border: 1px solid #5e85ef;
		border-radius: 100%;
	}
	/deep/ .status-icon .inner {
		border: 1px solid #f2f2f2;
		border-radius: 100%;
		width: 14px;
		height: 14px;
	}
	/deep/ .status-icon .inner.danger { background-color: #F4516C; }
	/deep/ .header-table-card .table-header-button:hover:before { opacity: 0; }
	.text-tarea-field {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		max-height: 50px;
	}
	/deep/ .text-tarea-field h1, /deep/ .text-tarea-field h2, /deep/ .text-tarea-field h3 { font-size: 1em !important; }
	.icon-container { flex-wrap: wrap; }
	.icon-container .icon-top {
		flex: 1 0 30%;
		width: 24px;
		max-width: 24px;
		height: 24px;
		max-height: 24px;
		margin-bottom: 2px;
	}
	.icon-container .icon-top.number {
		background-color: #2D4B95;
		text-align: center;
		line-height: 20px;
		width: 35px;
		max-width: 35px;
		border-radius: 5px;
	}
	.text-task-number.caption { font-size: 10px !important; }
	.icon-container .icon-top.total {
		background-color: #5E85EF;
		text-align: center;
		line-height: 20px;
	}
	.critical-date-container { background-color: #5E85EF; }
	.listing-loading-bar {
		position: absolute;
		bottom: 0;
	}
	.header-table-card {
		border: 1px solid white;
		display: flex;
		flex-direction: column;
	}
	.status-ended { border: 1px solid #4caf50; }
	.tarea-card { position: relative; }
	.incognito-container {
		width: 0;
		height: 0;
		border-top: 33px solid #616161;
		border-right: 33px solid transparent;
		border-radius: 0 !important;
		position: absolute;
		left: 0px;
	}
	.incognito-container .v-icon {
		position: absolute;
		top: -32px;
		left: 1px;
	}
	.float-total-icon {
		position: absolute;
		top: 0;
		right: 5px;
		bottom: 0;
	}
	.near-deadline { background-color: #fb8c00; }
	.payment-status-container:hover {
		box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	}
	.additional-list-title {
		white-space: normal;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1.1;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	/deep/ .additional-list-description p {
		margin-bottom: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.w-100 { width: 100%; }
	.custom-first-row-payment-status {
		position: sticky;
		left: 0;
		top: 0;
		z-index: 1;
		background-color: white;
		display: flex !important;
		align-items: stretch !important;
		justify-content: center !important;
		height: auto !important;
		box-shadow: 5px 0 10px -5px rgba(0, 0, 0, 0.3);
	}
	.custom-first-row-payment-status-header {
		position: sticky;
		left: 0;
		top: 0;
		z-index: 1;
		background-color: white;
		box-shadow: 5px 0 10px -5px rgba(0, 0, 0, 0.3);
	}
	.custom-first-row-payment-status > * {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: stretch;
		width: 100%;
	}
	/deep/ .custom-first-row-payment-status > * > div {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.status-text {
		display: inline-block;
		max-width: 150px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: bottom;
	}
	/deep/ .custom-input-numbers .v-input__slot { padding: 0 !important; min-height: 25px !important; }
	/deep/ .custom-input-numbers .v-input__prepend-inner,
	/deep/ .custom-input-numbers .v-input__append-inner,
	/deep/ .custom-text-input .v-input__append-inner { margin-top: 0 !important; }
	/deep/ .custom-input-numbers input { text-align: center; font-size: 12px; padding: 0; }
	.new-payment-status-container {
		padding: 12px;
		border: 2px dashed #2D4B95;
		border-radius: 6px;
		background-color: rgba(45, 75, 149, 0.04);
		white-space: normal;
		word-wrap: break-word;
		overflow-wrap: break-word;
	}
	.new-payment-status-container p {
		white-space: normal;
		word-wrap: break-word;
		overflow-wrap: break-word;
		word-break: break-word;
	}
	.action-btn {
		border-radius: 4px !important;
		text-transform: none !important;
		font-weight: 500 !important;
		padding: 6px 12px !important;
	}
	.action-btn-cancel {
		border-radius: 4px !important;
		text-transform: none !important;
		font-weight: 500 !important;
		padding: 6px 12px !important;
	}
	.mobile-ep-selector {
		width: 100%;
	}

	.listing-header-card{
		position: sticky;
		top: 0;
		z-index: 2;
		background: white;
	}
	.sticky-sentinel {
		height: 1px;
		pointer-events: none;
		visibility: hidden;
	}
	.sticky-collapsible {
		overflow: hidden;
		transition: max-height 0.4s ease, opacity 0.3s ease;
		max-height: 1200px;
		opacity: 1;
	}
	.sticky-collapsible.is-hidden {
		max-height: 0;
		opacity: 0;
	}

	/deep/ .currency-selector .v-input__control {
		min-height: 20px !important;
		height: 20px !important;
	}
	/deep/ .currency-selector .v-input__slot {
		min-height: 20px !important;
		height: 20px !important;
		padding: 0 8px !important;
	}
	/deep/ .currency-selector .v-select__selection {
		font-size: 0.70rem !important;
		margin-top: 0 !important;
		margin-bottom: 0 !important;
		line-height: 20px !important;
	}
	/deep/ .currency-selector .v-input__append-inner {
		margin-top: -2px !important;
		padding: 0 !important;
	}
	/deep/ .currency-selector .v-input__prepend-inner {
		margin-top: 0 !important;
		padding: 0 !important;
		align-self: center !important;
	}

	/* Alerta de filtro activo */
	.filter-active-alert {
		position: sticky;
		top: 0;
		z-index: 1;
	}
</style>